import React from "react";
import AppLayouts from "./AppLayouts";
import Routes from "../../app/routes";
import { useSelector } from "react-redux";

const AppLayout = (props) => {
  const horizontalNavPosition = useSelector(({settings}) => settings.horizontalNavPosition);
  const navigationStyle = useSelector(({settings}) => settings.navigationStyle);
  const { layoutOverride="" } = props; 

  const getLayout = (layoutOverride, navigationStyle, horizontalNavPosition) => {
    if ( layoutOverride !== "" ) {
      return layoutOverride;
    }

    if ( navigationStyle === "vertical_navigation") {
      return "Vertical";
    }

    switch (horizontalNavPosition) {
      case "inside_the_header":
        return "InsideHeaderNav";

      case "above_the_header":
        return "AboveHeaderNav";

      case "below_the_header":
        return "BelowHeaderNav";
      default:
        return "Vertical";
    }
  };

  const Layout = AppLayouts[getLayout(layoutOverride, navigationStyle, horizontalNavPosition)];
    return (
      <Layout>
        <Routes/>
      </Layout>
    );
};

export default AppLayout;
